<div class="container" [class.container--completed]="isCompleted">
  <div class="documents-sign-option" (click)="onOptionClick()">
    <div class="documents-sign-option__icon" [class.documents-sign-option__icon--completed]="isCompleted">
      <img *ngIf="!isCompleted" src="../../../../../../assets/icons/outline-document-text-1.svg" alt="" aria-hidden="true" />
      <img *ngIf="isCompleted" src="../../../../../assets/icons/tick-circle-green.svg" aria-hidden="true"/>
    </div>
    <div class="documents-sign-option__content">
      <p class="documents-sign-option__title">{{ title }}</p>
      <p class="documents-sign-option__description">{{ description }}</p>
    </div>
  </div>
  <div *ngIf="options?.length"
    [ngClass]="isDrawerOpened ? 'documents-sign-option__options drawer-show' : 'documents-sign-option__options drawer-hide'">
    <div *ngFor="let item of options">
      <app-checkbox [content]="item.label" [checked]="item.value" [disabled]="item.isDisabled"
        (selectionChanged)="item.value = $event" type="blue_checked"></app-checkbox>
    </div>
    <button type="button" (click)="selectOption()" [disabled]="!isOptionsSelected || isButtonDisabled || isSubmitting" class="documents-sign-option__options__button" >Continuar</button>
  </div>
</div>